import ComponentsFactory from 'foundation/components-factory';
import RightHeaderLinks from './js/right-header-links.component';

ComponentsFactory.getInstance().define('right-header-links', RightHeaderLinks);
